import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';
import classNames from 'classnames';

const messages = defineMessages({
  save: {
    id: 'primary.carousel.promotion.save',
    defaultMessage: 'SAVE {percent}%',
  },
  saveup: {
    id: 'primary.carousel.promotion.saveup',
    defaultMessage: 'SAVE UP TO {percent}%',
  },
  bundle: {
    id: 'primary.carousel.promotion.bundle',
    defaultMessage: 'NEW BUNDLE',
  },
  outnow: {
    id: 'primary.carousel.promotion.outnow',
    defaultMessage: 'OUT NOW',
  },
  endingsoon: {
    id: 'primary.carousel.promotion.endingsoon',
    defaultMessage: 'ENDING SOON',
  },
  preorder: {
    id: 'primary.carousel.promotion.preorder',
    defaultMessage: 'PRE-ORDER NOW',
  },
  coupon: {
    id: 'primary.carousel.promotion.coupon',
    defaultMessage: 'WITH COUPON',
  },
  outdate: {
    id: 'primary.carousel.promotion.outdate',
    defaultMessage: 'OUT',
  },
  lastchance: {
    id: 'primary.carousel.promotion.lastchance',
    defaultMessage: 'LAST CHANCE',
  },
});

const PrimaryMessage = ({
  customMessage,
  messageType,
  messageData,
  intl: { formatMessage },
}) => {
  const showMessage = splitMessage =>
    <div className="primary-message">
      {splitMessage.map(c =>
        <span key={c + Math.random()} className={classNames({ percentage: c.match(/\d|%|\$/g) })}>{c}</span>,
      )}
    </div>;

  let splitMessage = '';

  if (!messageType || messageType === 'none') {
    return (<div />);
  }

  if (messageType === 'save' && messageData && messageData.primary_percent_saving) {
    const saveMessage = formatMessage(messages.save, {
      percent: messageData.primary_percent_saving,
    });
    splitMessage = saveMessage.split('');
    return showMessage(splitMessage);
  }

  if (messageType === 'saveup' && messageData && messageData.primary_percent_saving) {
    const saveMessage = formatMessage(messages.saveup, {
      percent: messageData.primary_percent_saving,
    });

    splitMessage = saveMessage.split('');
    return showMessage(splitMessage);
  }

  if (messageType === 'custom') {
    const messageToSplit = customMessage || '';
    splitMessage = messageToSplit.split('');
    return showMessage(splitMessage);
  }

  const promotionalMessage = formatMessage(messages[messageType]);
  return (
    <div className="primary-message">{promotionalMessage}</div>
  );
};


PrimaryMessage.propTypes = {
  customMessage: PropTypes.string,
  messageType: PropTypes.string,
  messageData: PropTypes.shape({}),
  formatMessage: PropTypes.func,
};

PrimaryMessage.defaultProps = {
  customMessage: '',
  messageType: '',
  messageData: {},
  formatMessage: () => {},
};

export default injectIntl(PrimaryMessage);
